const css = `.copy-routine-button {
  position: relative;
}
.copy-routine-button .button-container {
  display: inline-block;
}
.copy-routine-button .copy-button {
  color: var(--primary-color);
  font-weight: var(--font-weight-medium);
  padding: 8px;
  min-height: auto;
}
.copy-routine-button .copy-button:hover {
  background: var(--accent-subtle);
  border-radius: var(--border-radius);
}
.copy-routine-button .copy-button .p-button-icon {
  margin-right: 8px;
}
.copy-routine-button .dropdown-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  overflow: hidden;
}
.copy-routine-button .dropdown-container .routine-dropdown {
  opacity: 0;
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  pointer-events: auto;
}
.copy-routine-button .custom-dropdown-container {
  position: absolute;
  z-index: 1000;
  width: 250px;
  max-width: 100vw;
  overflow: visible;
}
.copy-routine-button .custom-dropdown-container .custom-dropdown {
  background-color: var(--surface-overlay);
  border-radius: var(--border-radius);
  border: 1px solid var(--border);
  box-shadow: none;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.copy-routine-button .custom-dropdown-container .custom-dropdown .dropdown-search {
  padding: 12px;
  border-bottom: 1px solid var(--surface-border);
  flex-shrink: 0;
}
.copy-routine-button .custom-dropdown-container .custom-dropdown .dropdown-search .p-inputtext {
  width: 100%;
}
.copy-routine-button .custom-dropdown-container .custom-dropdown .dropdown-options-list {
  max-height: 300px;
  overflow-y: auto;
  flex-grow: 1;
}
.copy-routine-button .custom-dropdown-container .custom-dropdown .dropdown-options-list .dropdown-option-wrapper {
  cursor: pointer;
  padding: 0;
}
.copy-routine-button .custom-dropdown-container .custom-dropdown .dropdown-options-list .dropdown-option-wrapper:hover {
  background-color: var(--surface-hover);
}
.copy-routine-button .custom-dropdown-container .custom-dropdown .dropdown-options-list .empty-message {
  padding: 16px;
  text-align: center;
  color: var(--text-color-secondary);
}

.copy-routine-dialog .copy-routine-dialog-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.copy-routine-dialog .copy-routine-dialog-content .copy-type-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.copy-routine-dialog .copy-routine-dialog-content .copy-type-section.copy-type-section-disabled label {
  opacity: 0.5;
  pointer-events: none;
}
.copy-routine-dialog .copy-routine-dialog-content .copy-type-section .copy-type-options {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.copy-routine-dialog .copy-routine-dialog-content .copy-type-section .copy-type-options .copy-type-option {
  display: flex;
  align-items: center;
  gap: 8px;
}
.copy-routine-dialog .copy-routine-dialog-content .copy-type-section .copy-type-options .copy-type-option label {
  font-weight: var(--font-weight-medium);
  color: var(--text-muted);
}
.copy-routine-dialog .copy-routine-dialog-content .copy-day-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 8px;
  border-top: 1px solid var(--surface-200);
}
.copy-routine-dialog .copy-routine-dialog-content .copy-day-section .form-field {
  min-width: 200px;
}
.copy-routine-dialog .copy-routine-dialog-content .copy-day-section.copy-day-section-disabled label {
  opacity: 0.5;
  pointer-events: none;
}
.copy-routine-dialog .p-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.routine-select-modal .routine-select-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.routine-select-modal .routine-select-content .routine-select-search {
  width: 100%;
}
.routine-select-modal .routine-select-content .routine-select-search .p-inputtext {
  width: 100%;
}
.routine-select-modal .routine-select-content .routine-options-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 300px;
  overflow-y: auto;
}
.routine-select-modal .routine-select-content .routine-options-list .routine-option-wrapper {
  cursor: pointer;
  border-radius: var(--border-radius);
}
.routine-select-modal .routine-select-content .routine-options-list .routine-option-wrapper:hover {
  background-color: var(--surface-hover);
}
.routine-select-modal .routine-select-content .empty-message {
  padding: 16px;
  text-align: center;
  color: var(--text-color-secondary);
}

.routine-option-item {
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: var(--border-radius);
  transition: background-color 0.2s;
}
.routine-option-item .routine-type-dot {
  width: 12px;
  height: 12px;
  min-width: 12px;
  min-height: 12px;
  border-radius: 50%;
  border: 1px solid;
}
.routine-option-item .routine-type-dot.user {
  background-color: var(--accent-subtle);
  border-color: var(--accent);
}
.routine-option-item .routine-type-dot.template {
  background-color: var(--success-subtle);
  border-color: var(--success);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL2NvbXBvbmVudHMvQ29weVJvdXRpbmVCdXR0b24iLCJzb3VyY2VzIjpbIkNvcHlSb3V0aW5lQnV0dG9uLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTs7QUFFQTtFQUNFOztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBOztBQUdGO0VBQ0U7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUlKO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTtFQUNBOztBQUVBO0VBQ0U7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBOztBQUVBO0VBQ0U7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7OztBQVFSO0VBQ0U7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTtFQUNBOztBQUdFO0VBQ0U7RUFDQTs7QUFJSjtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtFQUNFO0VBQ0E7RUFDQTs7QUFDQTtFQUNFO0VBQ0E7O0FBTVI7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0U7O0FBSUE7RUFDRTtFQUNBOztBQU1SO0VBQ0U7RUFDQTtFQUNBOzs7QUFLRjtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtFQUNFOztBQUVBO0VBQ0U7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTs7QUFFQTtFQUNFOztBQUtOO0VBQ0U7RUFDQTtFQUNBOzs7QUFLTjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBOztBQUdGO0VBQ0U7RUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi5jb3B5LXJvdXRpbmUtYnV0dG9uIHtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuXG4gIC5idXR0b24tY29udGFpbmVyIHtcbiAgICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gIH1cblxuICAuY29weS1idXR0b24ge1xuICAgIGNvbG9yOiB2YXIoLS1wcmltYXJ5LWNvbG9yKTtcbiAgICBmb250LXdlaWdodDogdmFyKC0tZm9udC13ZWlnaHQtbWVkaXVtKTtcbiAgICBwYWRkaW5nOiA4cHg7XG4gICAgbWluLWhlaWdodDogYXV0bztcblxuICAgICY6aG92ZXIge1xuICAgICAgYmFja2dyb3VuZDogdmFyKC0tYWNjZW50LXN1YnRsZSk7XG4gICAgICBib3JkZXItcmFkaXVzOiB2YXIoLS1ib3JkZXItcmFkaXVzKTtcbiAgICB9XG5cbiAgICAucC1idXR0b24taWNvbiB7XG4gICAgICBtYXJnaW4tcmlnaHQ6IDhweDtcbiAgICB9XG4gIH1cblxuICAuZHJvcGRvd24tY29udGFpbmVyIHtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgdG9wOiAwO1xuICAgIGxlZnQ6IDA7XG4gICAgd2lkdGg6IDA7XG4gICAgaGVpZ2h0OiAwO1xuICAgIG92ZXJmbG93OiBoaWRkZW47XG5cbiAgICAucm91dGluZS1kcm9wZG93biB7XG4gICAgICBvcGFjaXR5OiAwO1xuICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgd2lkdGg6IDFweDtcbiAgICAgIGhlaWdodDogMXB4O1xuICAgICAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgICAgIGNsaXA6IHJlY3QoMCAwIDAgMCk7XG4gICAgICB3aGl0ZS1zcGFjZTogbm93cmFwO1xuICAgICAgcG9pbnRlci1ldmVudHM6IGF1dG87XG4gICAgfVxuICB9XG5cbiAgLmN1c3RvbS1kcm9wZG93bi1jb250YWluZXIge1xuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICB6LWluZGV4OiAxMDAwO1xuICAgIHdpZHRoOiAyNTBweDtcbiAgICBtYXgtd2lkdGg6IDEwMHZ3O1xuICAgIG92ZXJmbG93OiB2aXNpYmxlO1xuXG4gICAgLmN1c3RvbS1kcm9wZG93biB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1zdXJmYWNlLW92ZXJsYXkpO1xuICAgICAgYm9yZGVyLXJhZGl1czogdmFyKC0tYm9yZGVyLXJhZGl1cyk7XG4gICAgICBib3JkZXI6IDFweCBzb2xpZCB2YXIoLS1ib3JkZXIpO1xuICAgICAgYm94LXNoYWRvdzogbm9uZTtcbiAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG5cbiAgICAgIC5kcm9wZG93bi1zZWFyY2gge1xuICAgICAgICBwYWRkaW5nOiAxMnB4O1xuICAgICAgICBib3JkZXItYm90dG9tOiAxcHggc29saWQgdmFyKC0tc3VyZmFjZS1ib3JkZXIpO1xuICAgICAgICBmbGV4LXNocmluazogMDtcblxuICAgICAgICAucC1pbnB1dHRleHQge1xuICAgICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICB9XG4gICAgICB9XG5cbiAgICAgIC5kcm9wZG93bi1vcHRpb25zLWxpc3Qge1xuICAgICAgICBtYXgtaGVpZ2h0OiAzMDBweDtcbiAgICAgICAgb3ZlcmZsb3cteTogYXV0bztcbiAgICAgICAgZmxleC1ncm93OiAxO1xuXG4gICAgICAgIC5kcm9wZG93bi1vcHRpb24td3JhcHBlciB7XG4gICAgICAgICAgY3Vyc29yOiBwb2ludGVyO1xuICAgICAgICAgIHBhZGRpbmc6IDA7XG5cbiAgICAgICAgICAmOmhvdmVyIHtcbiAgICAgICAgICAgIGJhY2tncm91bmQtY29sb3I6IHZhcigtLXN1cmZhY2UtaG92ZXIpO1xuICAgICAgICAgIH1cbiAgICAgICAgfVxuXG4gICAgICAgIC5lbXB0eS1tZXNzYWdlIHtcbiAgICAgICAgICBwYWRkaW5nOiAxNnB4O1xuICAgICAgICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgICAgICAgICBjb2xvcjogdmFyKC0tdGV4dC1jb2xvci1zZWNvbmRhcnkpO1xuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICB9XG59XG5cbi5jb3B5LXJvdXRpbmUtZGlhbG9nIHtcbiAgLmNvcHktcm91dGluZS1kaWFsb2ctY29udGVudCB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgIGdhcDogMjRweDtcblxuICAgIC5jb3B5LXR5cGUtc2VjdGlvbiB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICAgIGdhcDogMTJweDtcblxuICAgICAgJi5jb3B5LXR5cGUtc2VjdGlvbi1kaXNhYmxlZCB7XG4gICAgICAgIGxhYmVsIHtcbiAgICAgICAgICBvcGFjaXR5OiAwLjU7XG4gICAgICAgICAgcG9pbnRlci1ldmVudHM6IG5vbmU7XG4gICAgICAgIH1cbiAgICAgIH1cblxuICAgICAgLmNvcHktdHlwZS1vcHRpb25zIHtcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICAgICAgZ2FwOiAxNnB4O1xuXG4gICAgICAgIC5jb3B5LXR5cGUtb3B0aW9uIHtcbiAgICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICAgICAgZ2FwOiA4cHg7XG4gICAgICAgICAgbGFiZWwge1xuICAgICAgICAgICAgZm9udC13ZWlnaHQ6IHZhcigtLWZvbnQtd2VpZ2h0LW1lZGl1bSk7XG4gICAgICAgICAgICBjb2xvcjogdmFyKC0tdGV4dC1tdXRlZCk7XG4gICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuXG4gICAgLmNvcHktZGF5LXNlY3Rpb24ge1xuICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgICBnYXA6IDE2cHg7XG4gICAgICBwYWRkaW5nLXRvcDogOHB4O1xuICAgICAgYm9yZGVyLXRvcDogMXB4IHNvbGlkIHZhcigtLXN1cmZhY2UtMjAwKTtcblxuICAgICAgLmZvcm0tZmllbGQge1xuICAgICAgICBtaW4td2lkdGg6IDIwMHB4O1xuICAgICAgfVxuXG4gICAgICAmLmNvcHktZGF5LXNlY3Rpb24tZGlzYWJsZWQge1xuICAgICAgICBsYWJlbCB7XG4gICAgICAgICAgb3BhY2l0eTogMC41O1xuICAgICAgICAgIHBvaW50ZXItZXZlbnRzOiBub25lO1xuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICB9XG5cbiAgLnAtZGlhbG9nLWZvb3RlciB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtZW5kO1xuICAgIGdhcDogMTJweDtcbiAgfVxufVxuXG4ucm91dGluZS1zZWxlY3QtbW9kYWwge1xuICAucm91dGluZS1zZWxlY3QtY29udGVudCB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgIGdhcDogMTZweDtcblxuICAgIC5yb3V0aW5lLXNlbGVjdC1zZWFyY2gge1xuICAgICAgd2lkdGg6IDEwMCU7XG5cbiAgICAgIC5wLWlucHV0dGV4dCB7XG4gICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgfVxuICAgIH1cblxuICAgIC5yb3V0aW5lLW9wdGlvbnMtbGlzdCB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICAgIGdhcDogOHB4O1xuICAgICAgbWF4LWhlaWdodDogMzAwcHg7XG4gICAgICBvdmVyZmxvdy15OiBhdXRvO1xuXG4gICAgICAucm91dGluZS1vcHRpb24td3JhcHBlciB7XG4gICAgICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgICAgICAgYm9yZGVyLXJhZGl1czogdmFyKC0tYm9yZGVyLXJhZGl1cyk7XG5cbiAgICAgICAgJjpob3ZlciB7XG4gICAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tc3VyZmFjZS1ob3Zlcik7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG5cbiAgICAuZW1wdHktbWVzc2FnZSB7XG4gICAgICBwYWRkaW5nOiAxNnB4O1xuICAgICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICAgICAgY29sb3I6IHZhcigtLXRleHQtY29sb3Itc2Vjb25kYXJ5KTtcbiAgICB9XG4gIH1cbn1cblxuLnJvdXRpbmUtb3B0aW9uLWl0ZW0ge1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBnYXA6IDhweDtcbiAgYm9yZGVyLXJhZGl1czogdmFyKC0tYm9yZGVyLXJhZGl1cyk7XG4gIHRyYW5zaXRpb246IGJhY2tncm91bmQtY29sb3IgMC4ycztcblxuICAucm91dGluZS10eXBlLWRvdCB7XG4gICAgd2lkdGg6IDEycHg7XG4gICAgaGVpZ2h0OiAxMnB4O1xuICAgIG1pbi13aWR0aDogMTJweDtcbiAgICBtaW4taGVpZ2h0OiAxMnB4O1xuICAgIGJvcmRlci1yYWRpdXM6IDUwJTtcbiAgICBib3JkZXI6IDFweCBzb2xpZDtcblxuICAgICYudXNlciB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1hY2NlbnQtc3VidGxlKTtcbiAgICAgIGJvcmRlci1jb2xvcjogdmFyKC0tYWNjZW50KTtcbiAgICB9XG5cbiAgICAmLnRlbXBsYXRlIHtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6IHZhcigtLXN1Y2Nlc3Mtc3VidGxlKTtcbiAgICAgIGJvcmRlci1jb2xvcjogdmFyKC0tc3VjY2Vzcyk7XG4gICAgfVxuICB9XG59XG4iXX0= */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
